module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/fondeadores/reporteria/saldo-fondeadores/saldo-fondeadores.component.scss
// module id = ./src/app/administracion/fondeadores/reporteria/saldo-fondeadores/saldo-fondeadores.component.scss
// module chunks = main